define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
	"csi/access/readOnly"
], function (csiAccess, access, full, readOnly) {

	const configEditRoles = ["Configuration Editor"];
	const configViewRoles = ["Configuration Viewer"];
	const workflowViewRoles = ["Workflow Viewer"];

	csiAccess.addViewRoles({
		"CamundaGlobal": {
			"CamundaProcessDefinitions": {
				"NewCamundaProcessDefinition": access(full(configEditRoles))
			}
		},

		"CamundaTask": {
			"HeaderView": {
				"CamundaViewActivity": access(full(workflowViewRoles))
			}
		},

		"EnumList": {
			"CamundaPriorityEnumLocale": {
				"": access(full(configEditRoles), readOnly(configViewRoles))
			}
		}
	});
});